(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@thingsw/pitta-design-system", "@material-ui/icons/Layers", "@material-ui/icons/Fullscreen", "@material-ui/icons/FullscreenExit", "@material-ui/icons/FilterList", "react", "@material-ui/core/styles", "clsx", "@material-ui/core", "@thingsw/pitta-modules", "../hoc/withStyleProvider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@thingsw/pitta-design-system"), require("@material-ui/icons/Layers"), require("@material-ui/icons/Fullscreen"), require("@material-ui/icons/FullscreenExit"), require("@material-ui/icons/FilterList"), require("react"), require("@material-ui/core/styles"), require("clsx"), require("@material-ui/core"), require("@thingsw/pitta-modules"), require("../hoc/withStyleProvider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pittaDesignSystem, global.Layers, global.Fullscreen, global.FullscreenExit, global.FilterList, global.react, global.styles, global.clsx, global.core, global.pittaModules, global.withStyleProvider);
    global.TopRightControl = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _pittaDesignSystem, _Layers, _Fullscreen, _FullscreenExit, _FilterList, _react, _styles, _clsx4, _core, _pittaModules, _withStyleProvider) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TopRightControl = void 0;
  _Layers = _interopRequireDefault(_Layers);
  _Fullscreen = _interopRequireDefault(_Fullscreen);
  _FullscreenExit = _interopRequireDefault(_FullscreenExit);
  _FilterList = _interopRequireDefault(_FilterList);
  _react = _interopRequireWildcard(_react);
  _clsx4 = _interopRequireDefault(_clsx4);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
  function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
  var useStyles = (0, _styles.makeStyles)(function (theme) {
    return {
      root: {
        "& > button": _objectSpread(_objectSpread({}, theme.direction === "rtl" ? {
          marginLeft: theme.spacing(1)
        } : {
          marginRight: theme.spacing(1)
        }), {}, {
          "&:last-child": _objectSpread({}, theme.direction === "rtl" ? {
            marginLeft: 0
          } : {
            marginRight: 0
          })
        })
      },
      roundRoot: {
        "& > button": {
          borderRadius: 12
        }
      },
      // mantis - 9421,9416 전체화면일 때 툴팁 안나오는 이슈도 함께 수정 (Leehj)
      iconColor: {
        "&:focus": {
          color: _pittaModules.LightColors.primary["1"]
        },
        "&:hover": _objectSpread({
          color: _pittaModules.LightColors.primary["7"]
        }, theme.direction === "rtl" ? {
          marginLeft: 0
        } : {
          marginRight: 0
        }),
        "&:not(:hover)": _objectSpread({}, theme.direction === "rtl" ? {
          marginLeft: 0
        } : {
          marginRight: 0
        }),
        margin: "0!important"
      },
      active: {
        color: _pittaModules.LightColors.primary["7"]
      },
      noHover: {
        "&:hover": {
          fill: _pittaModules.LightColors.primary["1"],
          color: _pittaModules.LightColors.primary["1"]
        },
        "&:active": {
          fill: _pittaModules.LightColors.primary["7"],
          color: _pittaModules.LightColors.primary["7"]
        }
      },
      noFocus: {
        "&:focus": {
          fill: _pittaModules.LightColors.primary["1"],
          color: _pittaModules.LightColors.primary["1"]
        }
      }
    };
  });
  var TopRightControlWithoutStyle = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
    var _t, _t2, _t3;
    var onFullscreen = _ref.onFullscreen,
      onLayers = _ref.onLayers,
      onDashcamPublic = _ref.onDashcamPublic,
      onEventLayers = _ref.onEventLayers,
      fullscreen = _ref.fullscreen,
      publicRef = _ref.publicRef,
      eventRef = _ref.eventRef,
      layerRef = _ref.layerRef,
      round = _ref.round,
      activePublic = _ref.activePublic,
      t = _ref.t;
    var classes = useStyles();
    var theme = (0, _core.useTheme)();
    var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(_pittaModules.Webviewer.mobile));

    // mantis - 7439, fullsize아이콘 툴팁 제어를 위하여 useState추가(Leehj)
    var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openFullSizeTooltip = _useState2[0],
      setOpenFullSizeTooltip = _useState2[1];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(classes.root, round && classes.roundRoot)
    }, onDashcamPublic && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
      disableTouchListener: mobile,
      title: (_t = t("Public cameras")) !== null && _t !== void 0 ? _t : "Public cameras",
      PopperProps: {
        disablePortal: true,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          flip: {
            enabled: false
          }
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
      onClick: onDashcamPublic,
      size: "small",
      variant: "rounded",
      className: (0, _clsx4["default"])(classes.noFocus, _defineProperty({}, classes.noHover, mobile)),
      ref: publicRef
    }, /*#__PURE__*/_react["default"].createElement(_FilterList["default"], null), !activePublic && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: _pittaModules.LightColors.primary["7"],
        position: "absolute",
        top: 3,
        right: 3
      }
    }))), onLayers && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
      disableTouchListener: mobile,
      title: (_t2 = t("Map type")) !== null && _t2 !== void 0 ? _t2 : "Map type",
      PopperProps: {
        disablePortal: true,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          flip: {
            enabled: false
          }
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
      size: "small",
      variant: "rounded"
      // ref={ref}
      // mantis - 12433, Map Type 선택 시 팝업 미노출 이슈 수정, layerRef로 적용 (Leehj)
      ,
      ref: layerRef,
      onClick: onLayers,
      className: (0, _clsx4["default"])(classes.noFocus, _defineProperty({}, classes.noHover, mobile))
    }, /*#__PURE__*/_react["default"].createElement(_Layers["default"], null))), onEventLayers && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
      disableTouchListener: mobile,
      title: (_t3 = t("Event type")) !== null && _t3 !== void 0 ? _t3 : "Event type",
      PopperProps: {
        disablePortal: true,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          flip: {
            enabled: false
          }
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
      size: "small",
      variant: "rounded",
      ref: eventRef,
      onClick: onEventLayers,
      className: (0, _clsx4["default"])(classes.noFocus, _defineProperty({}, classes.noHover, mobile))
    }, /*#__PURE__*/_react["default"].createElement(_Layers["default"], null))), onFullscreen && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip
    // mantis - 7439, fullsize아이콘 툴팁 제어를 위하여 툴팁 속성이용 (Leehj)
    , {
      PopperProps: {
        disablePortal: true,
        placement: "bottom-end",
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          flip: {
            enabled: false
          }
        }
      },
      open: openFullSizeTooltip,
      onOpen: function onOpen() {
        return setOpenFullSizeTooltip(true);
      },
      onClose: function onClose() {
        return setOpenFullSizeTooltip(false);
      },
      disableTouchListener: mobile,
      title: fullscreen ? "".concat(t("Exit fullscreen")) : "".concat(t("Fullscreen"))
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
      size: "small",
      variant: "rounded"
      // mantis - 7439, safari에서 지도 전체화면 종료 시에도 툴팁남아있는 이슈수정/ 아이콘 클릭하면 툴팁 close (Leehj)
      ,
      onClick: function onClick() {
        onFullscreen();
        setOpenFullSizeTooltip(false);
      },
      className: classes.iconColor
    }, fullscreen ? /*#__PURE__*/_react["default"].createElement(_FullscreenExit["default"], null) : /*#__PURE__*/_react["default"].createElement(_Fullscreen["default"], null))));
  });
  var TopRightControl = (0, _withStyleProvider.withStyleProvider)(TopRightControlWithoutStyle);
  _exports.TopRightControl = TopRightControl;
});